


















































































































































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { bus } from "@/bus";
// components
import vSelect from "vue-select";
import FolderTree from "@/components/common/folders/FolderTree.vue";
import FileDeleteModal from "@/components/files/modals/FileDeleteModal.vue";
import FilesDuplicatesModal from "@/components/files/modals/FilesDuplicatesModal.vue";
import FileAlertModal from "@/components/files/modals/FileAlertModal.vue";
import FileInfoSection from "@/components/files/FileInfo.vue";

// service methods
import { checkDelete, checkDuplicates, getFilteredFiles, postFile, updateName } from "@/services/files/fileService";
import { getApplicationSettings } from "@/services/applicationSettings/applicationSettingsService";
// types
import { FilesDuplicatesDtoIn, FilesFilterDtoIn, MediaType, Status, VscFile, FileNameUpdateDtoIn } from "@/services/files/types";
import { Folder, FolderEntites } from "@/services/folders/types";
import { ApplicationSettings } from "@/services/applicationSettings/types";
import { fileFields } from "@/components/files/fields/fileFields";
import { FILEENDPOINT } from "@/app.config";
import { FileManagerMode } from "@/components/files/types";
import i18n from "@/i18n";
import FileDeleteNotAllowedModal from "@/components/files/modals/FileDeleteNotAllowedModal.vue";

@Component({
    components: {
        vSelect,
        "folder-tree": FolderTree,
        "file-delete-modal": FileDeleteModal,
        "file-duplicates-modal": FilesDuplicatesModal,
        "file-alert-modal": FileAlertModal,
        "file-info": FileInfoSection,
        "file-delete-not-allowed-modal": FileDeleteNotAllowedModal
    }
})
export default class FileManager extends Vue {
    @Prop() private mode!: FileManagerMode;
    @Prop({ default: "" }) folderId!: string;
    @Prop({ default: "" }) fileId!: string;

    // local state
    vscFiles = [] as Array<VscFile>;
    fields = fileFields;
    isBusy = false;
    fileStatus = Status;
    applicationSettings = {} as ApplicationSettings;
    mediaTypes = MediaType;
    showDetails = false;
    selectedFile = {} as VscFile;
    selectedFileId = "";
    selectedMediaType = this.mediaTypes.Image;

    // sorting
    sortBy = "name" as string;
    sortDesc = false as boolean;

    // folders
    folderEntity = FolderEntites.Files;
    selectedFolderNode = {} as Folder;
    showFolderTree = true;

    // filter options
    searchText = "" as string;
    searchTimer = 0;

    // file name edit
    editFileId = "";
    editFileName = "";
    editFileExtension = "";
    renameError = "";

    // pagination
    currentPage = 1;
    itemsPerPage = 10;
    totalItems = 0;

    // selection events
    rowSelected(items: VscFile[]) {
        if (items.length > 0) {
            this.showDetails = true;
            this.selectedFile = items[0];
            this.selectedFileId = items[0].id;
            this.selectedMediaType = items[0].mediaType;
            this.$emit("fileSelected", this.selectedFile);
        } else {
            this.showDetails = false;
        }
    }

    // file upload
    private newFiles: File[] = [];
    private tmpNewFiles: File[] = [];
    dragActive = false;
    counter = 0;
    duplicateFiles: string[] = [];

    // lifecycle hooks
    public created(): void {
        if (!this.showFolderTree) {
            this.fetchData();
        }

        bus.$on("reload", () => {
            this.fetchData();
        });
    }

    beforeDestroy() {
        bus.$off("reload");
    }

    // methods & actions
    setFileFolderId(data: { entityId: string, folderId: string }) {
        this.vscFiles.forEach((file) => {
            if (file.id === data.entityId) file.folderId = data.folderId;
        });

        this.fetchData();
    }

    selectFolder(folder: Folder) {
        this.selectedFolderNode = folder;
        this.fetchData();
    }

    toggleFolderTree() {
        if (!this.filterActive) {
            this.showFolderTree = !this.showFolderTree;
        }
    }

    deleteFile(fileId: string, name: string) {
        checkDelete(fileId).then(response => {
            if (response.posts.length > 0 || response.templates.length > 0) {
                const posts = response.posts;
                const templates = response.templates;

                (this.$refs.fileDeleteNotAllowedModal as any).open(posts, templates);
                return;
            }
            (this.$refs.fileDeleteModal as any).open(fileId, name);
        });
    }

    addFile() {
        (this.$refs.dropZone as any).openFileSelection();
    }

    // we use this sorting approach to mimic the vue bootstrap table sorting
    customSort(items: VscFile[], sortBy: string, sortDesc: boolean = false) {
        const collator = new Intl.Collator(undefined, { numeric: true, sensitivity: "base" });

        return items.sort((a: any, b: any) => {
            let result = collator.compare(a[sortBy], b[sortBy]);
            if (sortDesc) {
                result *= -1;
            }
            return result;
        });
    }

    fetchData() {
        this.isBusy = true;

        let type = null; // fetch all files
        if (this.mode === FileManagerMode.Image) {
            type = this.mediaTypes.Image;
        }
        if (this.mode === FileManagerMode.Video) {
            type = this.mediaTypes.Video;
        }
        if (this.mode === FileManagerMode.ImageAndDocument) {
            type = this.mediaTypes.ImageAndDocument;
        }

        const filter =
            {
                mediaType: type,
                pageSize: this.itemsPerPage,
                searchQuery: this.searchText,
                folderId: this.selectedFolderNode ? this.selectedFolderNode.id : ""
            } as FilesFilterDtoIn;

        getFilteredFiles(filter).then(response => {
            this.totalItems = response.files.length;
            this.vscFiles = this.customSort(response.files, this.sortBy, this.sortDesc);

            if (this.fileId !== "") {
                const index = this.vscFiles.findIndex(file => file.id === this.fileId);

                // only if file exists (user has access to this file)
                if (index !== -1) {
                    // we need to wait pagination to be rendered in order the changes to be reflected on UI
                    this.$nextTick(() => {
                        this.currentPage = Math.floor(index / this.itemsPerPage) + 1;

                        // we need to wait after pagination is changed, the items to loaded on ui, so we can select.
                        this.$nextTick(() => {
                            const elem = document.getElementById(`filesTable__row_${this.fileId}`);
                            if (elem !== null) elem.click();
                        });
                    });
                }
            }
            this.isBusy = false;
        });

        getApplicationSettings({ keys: ["MaxUploadFileSize", "AllowedImageExtensions", "AllowedVideoExtensions", "OtherAllowedExtensions"] }).then(response => {
            this.applicationSettings = response;
        });
    }

    filterText() {
        clearTimeout(this.searchTimer);
        this.searchTimer = setTimeout(() => this.fetchData(), 300);
    }

    // computed and watchers

    get filterActive(): boolean {
        return (this.searchText !== "");
    }

    getFileSrc(file: VscFile): string {
        const nameParts = file.name.split(".");
        const extension = nameParts[nameParts.length - 1];
        if (extension.toLowerCase() === "svg") {
            return `${FILEENDPOINT}${file.originalFileId}`;
        }
        return file.thumbnailId
            ? `${FILEENDPOINT}${file.thumbnailId}` : "/test.jpg";
    }

    @Watch("filterActive")
    onFilterChanged(value: any, oldValue: any) {
        this.showFolderTree = !value;
    }

    @Watch("currentPage")
    onPropertyChanged(value: boolean, oldValue: any) {
        // temporary comment
        // this.fetchData();
    }

    // drag events
    entityMoveDrag(event: any) {
        event.dataTransfer.setDragImage(this.$refs["element_" + event.target.getAttribute("entityId")] as any, -10, 0);
        event.dataTransfer.setData(
            "type",
            event.target.getAttribute("type")
        );
        event.dataTransfer.setData(
            "folderEntity",
            event.target.getAttribute("folderEntity")
        );
        event.dataTransfer.setData(
            "entityId",
            event.target.getAttribute("entityId")
        );
        bus.$emit("calculate-drop-not-allowed", this.selectedFolderNode.id, event.target.getAttribute("type"));
    }

    // file upload
    containsFiles(event: DragEvent) {
        if (event && event.dataTransfer && event.dataTransfer.types) {
            return event.dataTransfer.types.some(x => x === "Files");
        }
        return false;
    }

    dropZoneDragEnter(event: DragEvent): void {
        if (this.filterActive) return;
        if (this.containsFiles(event)) {
            event.preventDefault();
            this.counter++;
            this.dragActive = true;
        }
    }

    dropZoneDragLeave(event: DragEvent): void {
        if (this.filterActive) return;
        if (this.containsFiles(event)) {
            this.counter--;
            if (this.counter === 0) {
                this.dragActive = false;
            }
        }
    }

    dropZoneOnDragOver(event: any): void {
        event.preventDefault();
    }

    dropZoneDrop(event: DragEvent | any): void {
        this.counter = 0;
        this.dragActive = false;
        event.preventDefault();

        this.tmpNewFiles = [...event.dataTransfer.files];
        this.validateFilesAndUpload();
    }

    openFileSelection(): void {
        (this.$refs.fileInput as any).click();
    }

    onFilesChanged(event: any) {
        this.tmpNewFiles = [...event.target.files];
        this.validateFilesAndUpload();
        event.target.value = "";
    }

    validateFilesAndUpload() {
        // check size
        if (this.applicationSettings.maxUploadFileSize === "" || this.tmpNewFiles.some(tmpFile => (tmpFile.size / 1048576) > parseInt(this.applicationSettings.maxUploadFileSize, 10))) {
            (this.$refs.fileAlertModal as any).open(i18n.t("file.fileSizeExceeds"));
            return;
        }

        let allowedExtension = this.applicationSettings.otherAllowedExtensions;
        switch (this.mode) {
        case FileManagerMode.Normal:
            allowedExtension += this.applicationSettings.allowedImageExtensions + this.applicationSettings.allowedVideoExtensions;
            break;
        case FileManagerMode.Image:
            allowedExtension += this.applicationSettings.allowedImageExtensions;
            break;
        case FileManagerMode.Video:
            allowedExtension += this.applicationSettings.allowedVideoExtensions;
            break;
        case FileManagerMode.ImageAndDocument:
            allowedExtension += this.applicationSettings.allowedImageExtensions + this.applicationSettings.otherAllowedExtensions;
            break;
        }

        // check extensions
        const tmpFileExtensions = this.tmpNewFiles.map(x => x.name.split(".").pop()!);
        if (allowedExtension === "" || tmpFileExtensions.some((tmpFileExtension: string) => !allowedExtension.toLowerCase().includes(tmpFileExtension.toLowerCase()))) {
            (this.$refs.fileAlertModal as any).open(i18n.t("file.extensionNotAllowed"));
            return;
        }

        // check duplicates
        const newlyAddedFiles = this.tmpNewFiles.map((x: File) => x.name);
        const activeFiles = this.vscFiles.filter(vscFile => vscFile.status === Status.uploading).map((x: VscFile) => x.name);
        const notAllowedFiles = activeFiles.filter(vscFile => newlyAddedFiles.includes(vscFile));
        if (notAllowedFiles.length > 0) {
            (this.$refs.fileDuplicatesModal as any).open(notAllowedFiles, true);
            return;
        }

        checkDuplicates({
            folderId: this.selectedFolderNode.id,
            files: this.tmpNewFiles.map(({ name }) => name)
        } as FilesDuplicatesDtoIn).then(response => {
            if (response.length > 0) {
                this.duplicateFiles = response;
                (this.$refs.fileDuplicatesModal as any).open(response, false);
            } else {
                this.startUpload();
            }
        });
    }

    async startUpload() {
        this.newFiles = [...this.tmpNewFiles, ...this.newFiles];
        this.tmpNewFiles = [];
        const vscNewFiles = this.newFiles.map((x: File) => ({
            id: "",
            name: x.name,
            isNew: true,
            folderId: this.selectedFolderNode.id,
            status: Status.uploading
        } as VscFile));
        this.vscFiles = this.vscFiles.filter(vscFile => !this.duplicateFiles.includes(vscFile.name));
        this.duplicateFiles = [];
        // vscNewFiles = vscNewFiles.filter(x => this.vscFiles.map(y => y.name).includes(x.name));
        this.vscFiles = [...vscNewFiles, ...this.vscFiles];

        const promises: Promise<any>[] = [];
        this.newFiles.forEach(file => {
            promises.push(this.sendRequest(file));
            this.totalItems++;
        });

        try {
            await Promise.all(promises);
            // do something after all of the promises have finished
        } catch (e) {
            // leave it for now...
        }
    }

    retryUpload(fileName: string) {
        const newFile = this.newFiles.find(f => f.name === fileName);
        const vscFileEntity = this.vscFiles.find(f => f.name === fileName);
        if (vscFileEntity) {
            vscFileEntity.status = Status.uploading;
            vscFileEntity.percentage = 0;
        }

        if (newFile !== undefined) {
            this.sendRequest(newFile);
        }
    }

    sendRequest(file: File) {
        const app = this;
        return new Promise((resolve, reject) => {
            const vscFileEntity = this.vscFiles.find(f => f.name === file.name);

            const config = {
                onUploadProgress: function (event: ProgressEvent) {
                    if (event.lengthComputable) {
                        if (vscFileEntity) {
                            // vscFileEntity.percentage = event.loaded / event.total * 90;
                            Vue.set(vscFileEntity, "percentage", event.loaded / event.total * 90);
                        }
                    }
                }
            };

            const formData = new FormData();
            formData.append("file", file, file.name);
            formData.append("folderId", this.selectedFolderNode.id);

            postFile(formData, config).then(
                response => {
                    if (vscFileEntity) {
                        vscFileEntity.id = response.id;
                        vscFileEntity.thumbnailId = response.thumbnailId;
                        vscFileEntity.originalFileId = response.originalFileId;
                        vscFileEntity.status = Status.done;
                        vscFileEntity.percentage = 100;
                        vscFileEntity.mediaType = response.mediaType;
                        setTimeout(function () { vscFileEntity.isNew = false; }, 2000);
                    }
                    const index = this.newFiles.findIndex(x => x.name === response.name);
                    if (index > -1) {
                        this.newFiles.splice(index, 1);
                    }
                    resolve(response);
                },
                error => {
                    if (vscFileEntity) {
                        vscFileEntity.status = Status.error;
                        vscFileEntity.percentage = 0;
                    }
                    reject(error);
                }
            );
        });
    }

    removeFile(fileName: string) {
        if (this.newFiles) {
            const index = this.newFiles.findIndex(x => x.name === fileName);
            if (index > -1) {
                this.newFiles.splice(index, 1);
                this.totalItems--;
            }
        }

        if (this.vscFiles) {
            const index = this.vscFiles.findIndex(x => x.name === fileName);
            if (index > -1) {
                this.vscFiles.splice(index, 1);
                this.totalItems--;
            }
        }
    }

    fileSrc(fileId: string): string {
        return `${FILEENDPOINT}${fileId}`;
    }

    get fileNameState() {
        if (this.editFileName.length === 0) {
            this.renameError = this.$t("file.noEmptyName").toString();
            return false;
        }
        if (this.vscFiles.some(x =>
            x.folderId === this.selectedFolderNode.id &&
            x.id !== this.editFileId &&
            x.name.toLowerCase() === this.newName.toLowerCase())) {
            this.renameError = this.$t("file.fileAlreadyExists").toString();
            return false;
        }
        return null;
    }

    get newName() {
        return `${this.editFileName}.${this.editFileExtension}`;
    }

    editName(vscFile: VscFile) {
        this.editFileId = vscFile.id;
        const nameParts = vscFile.name.split(".");
        this.editFileName = nameParts.slice(0, -1).join(".");
        this.editFileExtension = nameParts[nameParts.length - 1];
    }

    saveName(vscFile: VscFile) {
        if (this.fileNameState === false) {
            (this.$refs.fileAlertModal as any).open(this.renameError);
        } else {
            // call api for update
            updateName({
                id: this.editFileId,
                name: this.newName
            } as FileNameUpdateDtoIn).then(() => {
                vscFile.name = this.newName;
                this.editFileId = "";
                this.editFileName = "";
                this.editFileExtension = "";
            });
        }
    }

    closeEdit() {
        this.editFileId = "";
        this.editFileName = "";
        this.editFileExtension = "";
    }

    clearSearch() {
        this.searchText = "";
        this.fetchData();
    }
}
